import { Card, CardContent, Grid, Typography } from '@mui/material';

export default function GastosResumen({ gastos }) {
  const activos = gastos.filter(g => g.estado === 'ACTIVO');

  const total = activos.reduce(
    (sum, g) => sum + Number(g.monto),
    0
  );

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={6}>
        <Card>
          <CardContent>
            <Typography>Total Gastos</Typography>
            <Typography variant="h5">{total.toFixed(2)}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={6}>
        <Card>
          <CardContent>
            <Typography>Gastos Activos</Typography>
            <Typography variant="h5">{activos.length}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
